﻿import { Role } from '../role/role.model';
import { CentralStation } from '../centralstation/centralstation.model';
import { FeatureSet } from '../feature/featureset.model';
import { User } from "../user/user.model";
import { TimeBasedAccessControl } from "./timeBasedAccessControl.model";
import { DateUtil } from "../common/date";
import { map,filter,isEmpty} from 'underscore';

export class Group {

    public Id: number = 0;
    public Name: string = "";
    public Description: string = "";
    public CEID: number = 0;
    public IsActive: boolean = false;
    public IsDefault: boolean = false;
    public CreatedBy: number = 0;
    public CreatedOn: Date | string = "";
    public UpdatedBy: string;
    public UpdatedOn: Date | string = "";
    public RoleList: Array<Role> = [];
    public IncludeCityCSSubLimitation: number;
    public CityCSList: Array<CentralStation> = [];
    public FeatureSetList: Array<FeatureSet> = [];
    public AssociatedUsersList: Array<User> = [];
    public RoleSummary: string;
    public AssociatedRolesCount: number;
    public LabelsSummary: string;
    public AssocaitedLabelsCount: number;
    public IsRoleSelected: boolean = false;
    public IsTimeBasedAccessEnabled: boolean = false;
    public TimeBasedAccessControl: TimeBasedAccessControl;
    public GroupStatus: string = "";


    constructor(group: Group) {
        this.Id = group.Id || 0;
        this.Name = group.Name || "";
        this.Description = group.Description || "";
        this.CEID = group.CEID || 0;
        this.IncludeCityCSSubLimitation = group.IncludeCityCSSubLimitation;
        if (group.CityCSList && group.CityCSList.length > 0) {
            this.CityCSList = map(group.CityCSList, (item: CentralStation) => { return new CentralStation(item) });
        }

        if (group.RoleList && group.RoleList.length > 0) {
            this.RoleList = map(group.RoleList, (item: Role) => { return new Role(item) });
        }

        if (group.AssociatedUsersList && group.AssociatedUsersList.length > 0) {
            this.AssociatedUsersList = map(group.AssociatedUsersList, (item: User) => { return new User(item) });
        }

        this.IsTimeBasedAccessEnabled = group.IsTimeBasedAccessEnabled || false;
        if (this.IsTimeBasedAccessEnabled) {
            this.TimeBasedAccessControl = new TimeBasedAccessControl(group.TimeBasedAccessControl);
        }

        this.CreatedBy = group.CreatedBy || 0;
        this.UpdatedBy = group.UpdatedBy || "";
        this.FeatureSetList = group.FeatureSetList || [];
        this.IsActive = group.IsActive || false;
        this.IsDefault = group.IsDefault || false;
        this.RoleSummary = group.RoleSummary;
        this.AssociatedRolesCount = group.AssociatedRolesCount;
        this.LabelsSummary = group.LabelsSummary;
        this.AssocaitedLabelsCount = group.AssocaitedLabelsCount;

        this.CreatedOn = DateUtil.ConvertToLocalTimeZone(group.CreatedOn);
        this.UpdatedOn = DateUtil.ConvertToLocalTimeZone(group.UpdatedOn);
        this.GroupStatus  = group.GroupStatus == "Success" ? "" : group.GroupStatus;
    }

    validate(): boolean {
        if (this.Name) this.Name = this.Name.trim();
        if (this.Description) this.Description = this.Description.trim();

        return !(isEmpty(this.Name) || isEmpty(this.Description))
    }

    validateRoleSet(): boolean {
        this.IsRoleSelected = this.getAssociatedRoles().length > 0;
        return this.IsRoleSelected;
    }

    getAssociatedRoles(): Array<Role> {
        let roleList: Array<Role> = [];
        if (this.RoleList.length > 0) {
            roleList = filter(this.RoleList, (item: Role) => { return item.Id > 0 });
        }
        return roleList;
    }

    getClonedGroup(): Group {
        this.Id = 0;
        this.IsDefault = false;
        return this;
    }
}